// extracted by mini-css-extract-plugin
export default {"listado":"ListaTorneosDecada_listado__OjtbI","torneo":"ListaTorneosDecada_torneo__JE86D"};